import isPlainObject from 'lodash/fp/isPlainObject'
import { handleActions } from 'redux-actions'
import { getOrNull } from './selectors';

/** @function trueHandler that always returns true */
export const trueHandler = () => true

/** @function falseHandler that always returns false */
export const falseHandler = () => false

/** @function nullHandler that always returns null */
export const nullHandler = () => null

/**
 * creates a clone of payload if is array or plain object
 * else return the payload
 *
 * @param {any} payload
 * @return {any} cloned payload or original payload
 */
export const handlePayload = payload => {
  if (Array.isArray(payload)) return [...payload]
  if (isPlainObject(payload)) return { ...payload }
  return payload
}
/** @function payladHandler that returns action payload */
export const payloadHandler = (state, { payload }) => handlePayload(payload)

/** @function resultHandler that returns action payload result response */
export const resultHandler = (state, { payload }) => {
  // we can trigger empty success actions to use redux-saga-routines promises
  // with should fetch again implementation
  const result = getOrNull('result.response')(payload)
  if (!result) {
    return state
  }
  return handlePayload(result)
}

/** @function createInitialStateHandler that returns function to get initialState */
export const createInitialStateHandler = initialState => () => handlePayload(initialState)

/**
 * @typedef {Object} action - action descriptor
 * @property {String} type - action type
 * @property {any} payload - action payload
 * @property {any} meta - action meta
 */
/**
 * @typedef {function} reducerFunction
 * @param {any} state - reducer state
 * @param {action} action - action to reduce
 * @return {any} new state
 */

/**
 * creates common request reducer
 *
 * @param {String} requestType - request action type to set state true
 * @param {String} fulfillType - fulfill action type to set state false
 * @return {reducerFunction} reducer function
 */
export const createRequestingReducer = (requestType, fulfillType) => handleActions({
  [requestType]: trueHandler,
  [fulfillType]: falseHandler
}, false)

/**
 * creates common error reducer
 *
 * @param {String} failureType - failure action type to set state error
 * @param {String} cleanupType - cleanup action type to set state null
 * @return {reducerFunction} reducer function
 */
export const createErrorReducer = (failureType, cleanupType) => handleActions({
  [failureType]: payloadHandler,
  [cleanupType]: nullHandler
}, null)

/**
 * creates common success payload reducer
 *
 * @param {String} successType - success action type to set state
 * @param {String} cleanupType - cleanup action type to set state to initial state
 * @param {any} initialState - initial reducer state
 * @return {reducerFunction} reducer function
 */
export const createSuccessReducer = (
  successType,
  cleanupType,
  initialState,
  successHandler = payloadHandler
) => handleActions({
  [successType]: successHandler,
  [cleanupType]: createInitialStateHandler(initialState)
}, initialState)
